import React from "react";
import BootstrapCard from 'shared/components/bootstrapCardWithFilter/bootstrapCardWithFilter';
import PropTypes from 'prop-types';
import SovosTooltip from 'shared/sovos-tooltip/SovosTooltip';


const flaggedLabel = "Transactions with this status are called out for specific purposes, either triggered by a validation rule, or placed manually by a user. This status is used according to the user’s preferences, and these transactions are not considered for reporting.";
const ignoredLabel = "Transactions with this status will not accrue Use Tax.";
const postedLabel = "Transactions with this status will accrue Use Tax.";

class LinesDataContainer extends React.Component{   
  componentDidMount(){
    const period = this.getCurrentPeriod();
    this.props.lineDataActions.fetchLineDataInformation(period);
  }

  getCurrentPeriod = () => {
    const date = new Date();
    const month = date.getMonth() + 1;
    let realMonth = '';
    month < 10 ? realMonth = `0${month}` : realMonth = month;
    const year = date.getFullYear();
    const periodId = `${year}${realMonth}`;
    return periodId;
  }
   
  render(){
    const {Open, Ignored, Flagged, Posted} = this.props.linesCount;
    const openLabel = "No action is taken. Use Tax is neither accrued nor ignored and transactions in this status are not considered on reports.";

    return(
      <BootstrapCard 
        title={ `Lines Status` }
        height={ 380 }
        margin={ '0 0 0 10px' }
        padding={ 0 }
        hasFilter={ true }
      >
        <div className="line-data-container">
          <ul className="line-data-container__list">
            <SovosTooltip
              id="open"
              place="bottom"
              label={ openLabel }>

              <li><div><span>Open</span></div><div>{Open}</div></li>

            </SovosTooltip>
            <SovosTooltip
              id="ignored"
              place="bottom"
              label={ ignoredLabel }>

              <li><div><span>Ignored</span></div><div>{Ignored}</div></li>

            </SovosTooltip>
            <SovosTooltip
              id="flagged"
              place="bottom"
              label={ flaggedLabel }>

              <li><div><span>Flagged</span></div><div>{Flagged}</div></li>

            </SovosTooltip>
            <SovosTooltip
              id="posted"
              place="bottom"
              label={ postedLabel }>

              <li><div><span>Posted</span></div><div>{Posted}</div></li>

            </SovosTooltip>
          </ul>
        </div>
      </BootstrapCard>
    );
  }
}

LinesDataContainer.propTypes = {
  lineDataActions: PropTypes.shape({
    fetchLineDataInformation: PropTypes.func
  }).isRequired,
  linesCount: PropTypes.object.isRequired
};


export default LinesDataContainer;



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/linesData/LinesDataContainer.js